import upperFirst from "lodash-es/upperFirst";

import { DropdownItem } from "@/components";

import { HighlightColors, NoteActions, NoteActionToShortcut } from "./models";

export function getColorClass(color: HighlightColors): { bg: string; border: string } {
  switch (color) {
    case HighlightColors.RED:
      return { bg: "bg-error-100", border: "border-b-2 border-error-300" };
    case HighlightColors.YELLOW:
      return { bg: "bg-warning-100", border: "border-b-2 border-warning-300" };
    case HighlightColors.GREEN:
      return { bg: "bg-success-100", border: "border-b-2 border-success-300" };
    case HighlightColors.GRAY:
      return { bg: "bg-grayblue-100", border: "border-b-2 border-grayblue-300" };
    case HighlightColors.LIGHT_BLUE:
      return { bg: "bg-blue-100", border: "border-b-2 border-blue-300" };
    case HighlightColors.DARK_BLUE:
      return { bg: "bg-bluedark-100", border: "border-b-2 border-bluedark-300" };
    case HighlightColors.PURPLE:
      return { bg: "bg-purple-100", border: "border-b-2 border-purple-300" };
    case HighlightColors.PINK:
      return { bg: "bg-pink-100", border: "border-b-2 border-pink-300" };
    default:
      throw new Error(`Unsupported highlight color: ${color}`);
  }
}

export function getHighlightOptions(onColorChange: (color: HighlightColors) => void): DropdownItem[] {
  return [
    ...Object.values(HighlightColors).map<DropdownItem>(color => ({
      type: "button",
      icon: "letter-a",
      iconStyle: `${getColorClass(color).bg} p-1 rounded`,
      text: `${upperFirst(color)} highlight`,
      callback: () => onColorChange(color),
    })),
  ];
}

export function getNoteOptions(onSelect: (action: NoteActions) => void): DropdownItem[] {
  return [
    {
      type: "button",
      icon: "message-text-square",
      text: "Give examples",
      subtext: NoteActionToShortcut[NoteActions.EXAMPLES],
      callback: () => onSelect(NoteActions.EXAMPLES),
    },
    {
      type: "button",
      icon: "paragraph-spacing",
      text: "Explain more",
      subtext: NoteActionToShortcut[NoteActions.EXPLAIN],
      callback: () => onSelect(NoteActions.EXPLAIN),
    },
    {
      type: "button",
      icon: "sticker-square",
      text: "Blank note",
      subtext: NoteActionToShortcut[NoteActions.CREATE_NOTE],
      callback: () => onSelect(NoteActions.CREATE_NOTE),
    },
    {
      type: "button",
      icon: "file-question",
      text: "Simplify",
      subtext: NoteActionToShortcut[NoteActions.SIMPLIFY],
      callback: () => onSelect(NoteActions.SIMPLIFY),
    },
  ];
}
